import { useQueries } from '@tanstack/react-query'
import { queryKeys } from '@/lib/query-keys'
import { cmsService } from '@/services/cms'
import type { TeamCategory, TeamMember } from '@/services/cms'

const listParams = { limit: 200, offset: 0 }

export interface CategoryWithMembers {
  category: TeamCategory
  members: TeamMember[]
}

export function useTeam() {
  const [categoriesQuery, membersQuery] = useQueries({
    queries: [
      {
        queryKey: queryKeys.cms.teamCategories(listParams),
        queryFn: () => cmsService.getTeamCategories(listParams),
      },
      {
        queryKey: queryKeys.cms.teamMembers(listParams),
        queryFn: () => cmsService.getTeamMembers(listParams),
      },
    ],
  })

  const categories = categoriesQuery.data?.results ?? []
  const members = membersQuery.data?.results ?? []

  const categoriesWithMembers: CategoryWithMembers[] = categories.map(category => ({
    category,
    members: members.filter(m => m.category.id === category.id),
  }))

  return {
    categoriesWithMembers,
    categories,
    members,
    isLoading: categoriesQuery.isLoading || membersQuery.isLoading,
    isError: categoriesQuery.isError || membersQuery.isError,
    error: categoriesQuery.error ?? membersQuery.error,
  }
}
